import BackImage from './BackImage';

export default BackImage;
